import { MutationAction, VuexModule, getModule, Module } from 'vuex-module-decorators'
import store from '@/store/index'
import { LoginUser } from '@/domain/LoginUser'

export interface LoginStateInterface {
    isLogin: boolean;
    loginUserName: string;
}

/**
 * ログイン情報
 */
@Module({
    dynamic: true,
    store,
    name: "LoginStateModule",
    namespaced: true,
})
class LoginState extends VuexModule implements LoginStateInterface {
    /** ログイン状態 */
    isLogin = false
    /** ログインユーザID */
    loginUserId = ""
    /** ログインユーザ名 */
    loginUserName = ""

    /**
     * ログイン
     * @param authKey
     * @param loginUserId
     * @param loginUserName 
     */
    @MutationAction({ mutate: ["isLogin", "loginUserId", "loginUserName"] })
    public async login(loginUser: LoginUser) {
        sessionStorage.setItem("loginUser", JSON.stringify(loginUser))
        return {
            isLogin: true,
            loginUserId: loginUser.userId,
            loginUserName: loginUser.userName,
        }
    }

    /**
     * ログアウト
     */
    @MutationAction({ mutate: ["isLogin", "loginUserId", "loginUserName"] })
    public async logout() {
        sessionStorage.clear()
        return {
            isLogin: false,
            loginUserId: "",
            loginUserName: "",
        }
    }
}

export const LoginStateModule = getModule(LoginState);



